import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

/**
 * Indicateur discret affiché en bas à droite quand le réseau est indisponible.
 * Les fiches consultants déjà consultées restent lisibles hors ligne.
 */
export function OfflineIndicator() {
  const [offline, setOffline] = useState(() => typeof navigator !== "undefined" && !navigator.onLine);

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);
    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-4 right-4 z-50 flex items-center gap-2 rounded-full border border-border/60 bg-card/95 px-4 py-2 shadow-elegant backdrop-blur-sm"
    >
      <WifiOff className="w-4 h-4 text-muted-foreground" aria-hidden="true" />
      <span className="text-xs font-montserrat text-muted-foreground">
        Hors ligne — consultation des données déjà chargées
      </span>
    </div>
  );
}
